import vStack from "./v-stack.vue";

export default Vue => {
  Vue.component("v-stack", vStack);
};
